import React, { Component } from 'react';

import TimeoutSignsParkinglocationsSelect from './TimeoutSignsParkinglocationsSelect';

import { Form, Input, InputNumber, Button, Modal, Select, Divider, Switch, Icon, TimePicker, Col } from 'antd';
import { withState } from 'recompose';
import moment from 'moment';
import { values } from 'lodash';
const FormItem = Form.Item;

class LcSignsForm extends Component {

    state = {
        modalVisible: false
    }

    form = null;

    componentWillReceiveProps(nextProps) {
        this.setState({
            modalVisible: nextProps.modalVisible
        });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                this.props.onSuccess(this.props.form, values);
            }
        });
    }

    renderForm() {
        const { getFieldDecorator } = this.props.form;

        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 6 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 18 },
            },
        };

        const tailFormItemLayout = {
            wrapperCol: {
                xs: {
                    span: 24,
                    offset: 0,
                },
                sm: {
                    span: 16,
                    offset: 8,
                },
            },
        };

        return (
            <Form onSubmit={this.handleSubmit} ref={ref => { this.form = ref }}>
                <FormItem
                    {...formItemLayout}
                    label="Sériové číslo" >
                    {getFieldDecorator('serialNumber', {
                        initialValue: this.props.initialValues && this.props.initialValues.serialNumber
                            ? this.props.initialValues.serialNumber
                            : null,
                        rules: [{
                            required: true, message: 'Vyplňte prosím tuto položku!',
                        }],
                    })(
                        <Input />
                    )}
                </FormItem>
                <FormItem
                    {...formItemLayout}
                    label="Popis" >
                    {getFieldDecorator('description', {
                        initialValue: this.props.initialValues && this.props.initialValues.description !== null
                            ? this.props.initialValues.description
                            : '',
                    })(
                        <Input.TextArea autosize={{ minRows: 2, maxRows: 4 }} />
                    )}
                </FormItem>
                <FormItem
                    {...formItemLayout}
                    label="Událost" >
                    {getFieldDecorator('eventListener', {
                        initialValue: this.props.initialValues && this.props.initialValues.eventListener
                            ? this.props.initialValues.eventListener
                            : null,
                        rules: [{
                            required: true, message: 'Vyplňte prosím tuto položku!',
                        }],
                    })(
                        <Input />
                    )}
                </FormItem>
                <FormItem
                    {...formItemLayout}
                    label="Schema" >
                    {getFieldDecorator('expression', {
                        initialValue: this.props.initialValues && this.props.initialValues.expression
                            ? this.props.initialValues.expression
                            : null,
                        rules: [{
                            required: true, message: 'Vyplňte prosím tuto položku!',
                        }],
                    })(
                        <Input />
                    )}
                </FormItem>
                <FormItem
                    {...formItemLayout}
                    label="Lokalita" >
                    {getFieldDecorator('corelocationId', {
                        initialValue: this.props.initialValues && this.props.initialValues.corelocationId
                            ? this.props.initialValues.corelocationId
                            : undefined,
                        rules: [{
                            required: true, message: 'Vyplňte prosím tuto položku!',
                        }],
                    })(
                        <TimeoutSignsParkinglocationsSelect onChange={(value) => { this.props.form.setFieldsValue({ coreParkingLocationId: value }); }} />
                    )}
                </FormItem>
                <FormItem
                    {...formItemLayout}
                    label="Počet digitů" >
                    {getFieldDecorator('digits', {
                        initialValue: this.props.initialValues && this.props.initialValues.digits
                            ? this.props.initialValues.digits
                            : 2,
                        rules: [{
                            required: true, message: 'Vyplňte prosím tuto položku!',
                            type: 'number', message: 'Položka musí obsahovat číslo!'
                        }],
                    })(
                        <InputNumber />
                    )}
                </FormItem>
                <FormItem
                    {...formItemLayout}
                    label="IP" >
                    {getFieldDecorator('ipAddress', {
                        initialValue: this.props.initialValues && this.props.initialValues.ipAddress
                            ? this.props.initialValues.ipAddress
                            : null,
                        rules: [{
                            required: true, message: 'Vyplňte prosím tuto položku!',
                        }],
                    })(
                        <Input />
                    )}
                </FormItem>
                <FormItem
                    {...formItemLayout}
                    label="Port" >
                    {getFieldDecorator('port', {
                        initialValue: this.props.initialValues && this.props.initialValues.port
                            ? this.props.initialValues.port
                            : null,
                        rules: [{
                            required: true, message: 'Vyplňte prosím tuto položku!',
                            type: 'number', message: 'Položka musí obsahovat číslo!'
                        }],
                    })(
                        <InputNumber />
                    )}
                </FormItem>
                <FormItem
                    {...formItemLayout}
                    label="Adresa 485" >
                    {getFieldDecorator('address_485', {
                        initialValue: this.props.initialValues && this.props.initialValues.address_485 !== undefined
                            ? this.props.initialValues["address_485"]
                            : null,
                        rules: [{
                            required: true, message: 'Vyplňte prosím tuto položku!',
                            type: 'number', message: 'Položka musí obsahovat číslo!'
                        }],
                    })(
                        <InputNumber />
                    )}
                </FormItem>
                <FormItem
                    {...formItemLayout}
                    label="Telefonní číslo SIM" >
                    {getFieldDecorator('phoneNumber', {
                        initialValue: this.props.initialValues && this.props.initialValues.phoneNumber
                            ? this.props.initialValues.phoneNumber
                            : null,
                    })(
                        <Input />
                    )}
                </FormItem>
                <FormItem
                    {...formItemLayout}
                    label="Zeměpisná šířka" >
                    {getFieldDecorator('latitude', {
                        initialValue: this.props.initialValues && this.props.initialValues.latitude
                            ? this.props.initialValues.latitude
                            : 0,
                        rules: [{
                            required: true, message: 'Vyplňte prosím tuto položku!',
                            type: 'number', message: 'Položka musí obsahovat číslo!',
                        }],
                    })(
                        <InputNumber
                            style={{ width: '120px' }}
                        />
                    )}
                </FormItem>
                <FormItem
                    {...formItemLayout}
                    label="Zeměpisná výška" >
                    {getFieldDecorator('longitude', {
                        initialValue: this.props.initialValues && this.props.initialValues.longitude
                            ? this.props.initialValues.longitude
                            : 0,
                        rules: [{
                            required: true, message: 'Vyplňte prosím tuto položku!',
                            type: 'number', message: 'Položka musí obsahovat číslo!',
                        }],
                    })(
                        <InputNumber
                            style={{ width: '120px' }}
                        />
                    )}
                </FormItem>
                <FormItem
                    {...formItemLayout}
                    label="Běžící"
                    style={{ display: this.props.initialValues ? 'block' : 'none' }}>
                    {getFieldDecorator('started', {
                        valuePropName: 'checked',
                        initialValue: this.props.initialValues && this.props.initialValues.started
                            ? this.props.initialValues.started
                            : false,
                    })(
                        <Switch
                            checkedChildren={<Icon type="check" />}
                            unCheckedChildren={<Icon type="close" />} />
                    )}
                </FormItem>
                <FormItem
                    {...formItemLayout}
                    label="Aktivní"
                    style={{ display: this.props.initialValues ? 'block' : 'none' }}>
                    {getFieldDecorator('active', {
                        valuePropName: 'checked',
                        initialValue: this.props.initialValues && this.props.initialValues.active
                            ? this.props.initialValues.active
                            : false,
                    })(
                        <Switch
                            checkedChildren={<Icon type="check" />}
                            unCheckedChildren={<Icon type="close" />} />
                    )}
                </FormItem>
                <FormItem {...tailFormItemLayout}>
                    {this.props.initialValues
                        ?
                        <Button type="primary" htmlType="submit">Uložit</Button>
                        :
                        <Button type="primary" htmlType="submit">Vložit</Button>
                    }
                </FormItem>
            </Form>
        );
    }

    render() {
        if (this.props.type && this.props.type === 'modal') {
            return (
                <Modal
                    width={700}
                    title={this.props.initialValues ? "Nastavení LC tabule" : "Vložení nové LC tabule"}
                    visible={this.state.modalVisible}
                    maskClosable={false}
                    onCancel={() => {
                        this.props.onModalCancel(this.props.form);
                        this.setState({ modalVisible: false });
                    }}
                    okText={this.props.initialValues ? "Uložit" : "Vložit"}
                >
                    {this.renderForm()}
                </Modal>
            )
        } else {
            return this.renderForm();
        }
    }
}

const WrappedLcSignsForm = Form.create()(LcSignsForm);

export default WrappedLcSignsForm;


// WEBPACK FOOTER //
// ./src/components/LcSignsForm.js